import { Navigate } from 'react-router';
import { agentPoolsTabPath } from '@/components/agent-pools-admin/agent-pools-tabs';

export default function SingleCamAgentAdminPage() {
  return <Navigate to={agentPoolsTabPath('singlecam')} replace />;
}
